import PropTypes from 'prop-types'
import { useTheme } from '@emotion/react'
import { graphql } from 'gatsby'
import { Container, Section } from 'chaoskit/src/components'
import { darkerBlueDarkestBlue } from 'chaoskit/src/assets/styles/utility/gradient'

import BaseLayout from '~layouts/BaseLayout'
import Data from '~components/Data'
import Hero, { HeroContent, HeroTitleWrapper, HeroTitle } from '~partials/Hero'
import HelmetSEO from '~partials/global/HelmetSEO'

const Terms = ({
  data: {
    file: {
      childMdx: { body, frontmatter: pageData },
    },
  },
}) => {
  const theme = useTheme()

  return (
    <BaseLayout>
      <HelmetSEO title={pageData.title} description={pageData.description} />
      <Hero compact css={{ ...darkerBlueDarkestBlue(theme) }}>
        <HeroContent>
          <Container>
            <HeroTitleWrapper>
              <HeroTitle>
                <Data>{pageData.hero.heading}</Data>
              </HeroTitle>
            </HeroTitleWrapper>
          </Container>
        </HeroContent>
      </Hero>
      <Section>
        <Container size="small">
          <Data markdown>{body}</Data>
        </Container>
      </Section>
    </BaseLayout>
  )
}

Terms.propTypes = {
  data: PropTypes.object.isRequired,
}

export default Terms

export const pageQuery = graphql`
  query TermsPageData {
    file(name: { eq: "terms" }, absolutePath: { regex: "/src/data/" }) {
      childMdx {
        body
        frontmatter {
          title
          description
          hero {
            heading
          }
        }
      }
    }
  }
`
